var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",class:{english: _vm.$route.params.lang==='EN'},attrs:{"id":"app"}},[_c('Navigation'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }